import { TOGGLE_FEATURE } from "../constants";
import get from "lodash/get";

function GET_FEATURE_FLAG_FROM_LS() {
  try {
    return localStorage.getItem("featureFlags")
      ? JSON.parse(localStorage.getItem("featureFlags"))
      : {};
  } catch (err) {
    return {};
  }
}

export function haveAccessToFeature(feature) {
  const featureFlags = GET_FEATURE_FLAG_FROM_LS();
  const hasAccess = featureFlags.hasOwnProperty(feature)
    ? featureFlags[feature]
    : false;

  if (hasAccess) {
    return true;
  }

  return false;
}

export function getFlagValue(feature) {
  const featureFlags = GET_FEATURE_FLAG_FROM_LS();
  return featureFlags[feature];
}

export function isGlobalFeatureEnabled(feat) {
  try {
    const features = localStorage.getItem(TOGGLE_FEATURE);
    const featuresJson = JSON.parse(features);
    return get(featuresJson, feat, false);
  } catch (e) {
    return false;
  }
}

export const getMexApiMigrations = (feature) => {
  try {
    let flags = JSON.parse(localStorage.getItem("mexApiMigrations"));
    return get(flags, feature) || false;
  } catch (e) {
    console.log(
      "error parsing the flag value from localstorage: mexApiMigrations",
      e
    );
    return false;
  }
};

export const isWebloginFeatureEnabled = () => {
  try {
    // This is due to MEX portal can be opened through a WebView that would need to be authenticated
    // so we can't use weblogin in this case and need to fallback to the old flow instead. When using
    // cookie authn, the JWT will be empty so ideally under normal circumstances whenever the JWT is
    // injected to the WebView, we should be able to fallback to use the old flow while the normal
    // weblogin flow shouldn't be affected.
    const jwtToken = localStorage.getItem("JWT");
    // As of now, this fn is being called in 3 places, help center check, isLoggedIn check and in 
    // changeLanguage fn. In help center check and changeLanguage fn, they're "guarded" by the isLoggedIn
    // check. In isLoggedIn check, under normal circumstances, the JWT should be empty for cookie authn
    // case, while in injected session WebView case, it'll be present so we can falback to the old flow.
    // We don't need the unauthenticated path check here since all these 3 functions are more or less being 
    // called in sidebar component, which would only be shown in authenticated state.
    return !jwtToken
  } catch (e) {
    return false;
  }
};
